import React from 'react';

const PlantIcon = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 98 78"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M61.2843 72.1685H36.2499L32.6953 41.8867H64.8389L61.2843 72.1685Z" fill="#F2B0AC" />
      <mask
        id="mask0_356_141793"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="32"
        y="41"
        width="33"
        height="32"
      >
        <path d="M61.2843 72.1685H36.2499L32.6953 41.8867H64.8389L61.2843 72.1685Z" fill="white" />
      </mask>
      <g mask="url(#mask0_356_141793)">
        <g opacity="0.5">
          <path
            d="M39.054 36.375L38.5645 83.3373"
            stroke="#E6948F"
            strokeWidth="3.0073"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M45.373 31.9141C45.2608 36.2075 45.8772 83.336 45.8772 83.336"
            stroke="#E6948F"
            strokeWidth="3.0073"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M30.8144 36.125C30.7022 39.4865 31.3186 76.3882 31.3186 76.3882"
            stroke="#E6948F"
            strokeWidth="3.0073"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M54.3006 29.6956C54.3566 38.1721 52.3047 80.5543 52.3047 80.5543"
            stroke="#E6948F"
            strokeWidth="3.0073"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M60.0887 28.5234C60.11 30.7701 58.9414 81.7391 58.9414 81.7391"
            stroke="#E6948F"
            strokeWidth="3.0073"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M65.3504 47.8594C64.7599 52.3912 66.2101 81.7411 66.2101 81.7411"
            stroke="#E6948F"
            strokeWidth="3.0073"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M30.9453 44.1799C37.1672 44.0784 65.6757 45.1942 71.1103 44.1055"
            stroke="#E6948F"
            strokeWidth="3.0073"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M29.5586 51.451C33.8157 51.3716 65.079 54.0286 70.4461 53.7206"
            stroke="#E6948F"
            strokeWidth="3.0073"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M27.6953 59.2848C32.5869 59.2068 67.392 60.4312 67.392 60.4312"
            stroke="#E6948F"
            strokeWidth="3.0073"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.6992 66.5154C32.3975 66.604 68.444 68.0659 68.444 68.0659"
            stroke="#E6948F"
            strokeWidth="3.0073"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <path
        d="M45.3675 17.3184C50.019 17.3184 53.7898 13.5578 53.7898 8.91895C53.7898 4.28008 50.019 0.519531 45.3675 0.519531C40.7161 0.519531 36.9453 4.28008 36.9453 8.91895C36.9453 13.5578 40.7161 17.3184 45.3675 17.3184Z"
        fill="#F8D987"
      />
      <path
        d="M44.4902 2.24947C48.1839 1.76557 51.571 4.35963 52.0562 8.04332"
        stroke="#F0C06E"
        strokeWidth="1.80438"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.2457 15.5907C43.9374 15.8929 41.7482 14.9934 40.313 13.3764C39.4519 12.4064 38.8619 11.1781 38.6797 9.79688"
        stroke="#F0C06E"
        strokeWidth="1.80438"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.8154 4.58466L44.8807 5.08052C45.2135 5.07121 45.5037 5.10179 45.7516 5.1718C45.9995 5.24181 46.2244 5.36811 46.4265 5.55023C46.5851 5.68804 46.7127 5.83471 46.81 5.99025C46.9068 6.14579 46.9646 6.29202 46.9824 6.42983C47.0024 6.58271 46.9637 6.72229 46.8669 6.84858C46.77 6.97487 46.6411 7.04843 46.4816 7.06926C46.1808 7.1087 45.9649 6.97221 45.8329 6.65937C45.6814 6.29024 45.4041 6.06824 45.0007 5.99336L45.2522 7.90233C45.6463 7.95639 45.9618 8.01179 46.1986 8.06806C46.4354 8.12434 46.6536 8.22182 46.8526 8.36052C47.065 8.5041 47.2379 8.68578 47.3716 8.90646C47.5054 9.12713 47.5902 9.37661 47.6271 9.65489C47.6729 10.0036 47.6338 10.3413 47.5098 10.667C47.3858 10.9931 47.177 11.2732 46.8833 11.5076C46.5896 11.742 46.2257 11.9064 45.792 12.0008L45.9427 13.1436C45.9662 13.324 45.9662 13.4582 45.9418 13.5451C45.9173 13.6324 45.8453 13.6838 45.7258 13.6993C45.6152 13.7139 45.5334 13.69 45.4801 13.6288C45.4268 13.5672 45.3908 13.4662 45.3721 13.3253L45.2091 12.0863C44.8447 12.0934 44.5199 12.0504 44.2347 11.9574C43.9494 11.8639 43.7041 11.7336 43.4997 11.5656C43.2949 11.3981 43.1363 11.2165 43.023 11.021C42.9097 10.8256 42.8404 10.6289 42.8141 10.4299C42.7946 10.2832 42.835 10.1432 42.9346 10.0103C43.0341 9.87734 43.1696 9.7998 43.3416 9.7772C43.4797 9.75903 43.6006 9.77586 43.7041 9.82771C43.8077 9.87955 43.8854 9.96109 43.9378 10.0728C44.0538 10.3129 44.1511 10.4955 44.2298 10.6205C44.3084 10.7454 44.4173 10.8549 44.5564 10.9488C44.695 11.0428 44.8709 11.1052 45.0842 11.1363L44.8034 9.00217C44.3773 8.94279 44.0174 8.8617 43.7228 8.75845C43.4282 8.65565 43.1785 8.48682 42.9728 8.25196C42.767 8.01755 42.6377 7.69805 42.5844 7.29437C42.5151 6.76838 42.6262 6.31462 42.9181 5.93397C43.2096 5.55333 43.6695 5.2941 44.2973 5.15585L44.2333 4.6693C44.1996 4.41229 44.2791 4.27093 44.4724 4.24567C44.6657 4.22041 44.7834 4.33252 44.8163 4.58333L44.8154 4.58466ZM44.6457 7.80972L44.4142 6.05185C44.1667 6.16218 43.9787 6.28936 43.8512 6.43382C43.7237 6.57828 43.6766 6.77724 43.7099 7.03115C43.7432 7.28506 43.8334 7.4468 43.9845 7.55315C44.1356 7.6595 44.356 7.74503 44.6457 7.80972ZM45.4095 9.09611L45.6743 11.1061C45.976 11.0042 46.199 10.8491 46.3434 10.6404C46.4874 10.4317 46.5434 10.2035 46.5105 9.95577C46.4754 9.68945 46.3661 9.49448 46.183 9.37085C45.9995 9.24722 45.7418 9.15549 45.4095 9.09655V9.09611Z"
        fill="#F0C06E"
      />
      <path
        d="M63.4681 30.6193C67.1029 30.6193 70.0495 27.6807 70.0495 24.0557C70.0495 20.4308 67.1029 17.4922 63.4681 17.4922C59.8333 17.4922 56.8867 20.4308 56.8867 24.0557C56.8867 27.6807 59.8333 30.6193 63.4681 30.6193Z"
        fill="#F8D987"
      />
      <path
        d="M73.6318 26.1992C73.4646 26.9862 73.2025 27.7661 72.8398 28.5239"
        stroke="#1A1A1A"
        strokeWidth="1.80438"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M72.4258 18.8047C73.358 20.3893 73.8596 22.2048 73.861 24.0566"
        stroke="#1A1A1A"
        strokeWidth="1.80438"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M65.7422 19.3125C68.3686 20.5648 69.4794 23.703 68.2242 26.3223"
        stroke="#F0C06E"
        strokeWidth="1.80438"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M61.194 28.7986C59.5527 28.016 58.5032 26.4966 58.253 24.8278C58.1033 23.8263 58.241 22.7712 58.712 21.7888"
        stroke="#F0C06E"
        strokeWidth="1.80438"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M64.96 20.9831L64.7911 21.3354C65.0128 21.4706 65.1901 21.6141 65.3225 21.7652C65.4549 21.9168 65.5482 22.0949 65.6029 22.2996C65.6478 22.4574 65.6691 22.6076 65.666 22.7507C65.6629 22.8939 65.638 23.014 65.5913 23.1119C65.5394 23.2209 65.454 23.2958 65.3367 23.337C65.219 23.3786 65.1035 23.372 64.9902 23.3179C64.7765 23.216 64.6929 23.0348 64.7405 22.7738C64.7987 22.4676 64.712 22.2044 64.4801 21.9841L63.8291 23.3419C64.0642 23.5448 64.2473 23.715 64.3783 23.8523C64.5094 23.9897 64.6107 24.1461 64.6818 24.3221C64.7596 24.5064 64.7951 24.6987 64.7884 24.9003C64.7818 25.1015 64.7311 25.3014 64.636 25.499C64.517 25.7472 64.3472 25.9514 64.1268 26.1123C63.9065 26.2731 63.6496 26.368 63.3573 26.3968C63.0645 26.4256 62.7561 26.3786 62.4317 26.2563L62.0421 27.069C61.9807 27.1975 61.923 27.2848 61.8701 27.3318C61.8168 27.3787 61.7475 27.3818 61.6626 27.3411C61.584 27.3034 61.5404 27.2533 61.532 27.1904C61.5231 27.1275 61.5431 27.0459 61.5911 26.9458L62.0136 26.0649C61.7719 25.9151 61.5777 25.7489 61.4307 25.5664C61.2836 25.3838 61.1787 25.1946 61.1165 24.9974C61.0539 24.8006 61.0277 24.6141 61.037 24.4382C61.0463 24.2622 61.085 24.1036 61.1525 23.9622C61.2027 23.8577 61.2885 23.7832 61.4107 23.7385C61.5324 23.6937 61.6546 23.7004 61.7768 23.7589C61.875 23.8058 61.947 23.8679 61.9927 23.9458C62.0385 24.0238 62.0545 24.1102 62.0412 24.2055C62.0145 24.412 62.0003 24.5729 61.9985 24.6885C61.9967 24.8042 62.0212 24.9221 62.0723 25.0421C62.1229 25.1627 62.2118 25.2783 62.338 25.3895L63.0653 23.8723C62.8116 23.6525 62.6104 23.446 62.4615 23.2537C62.3127 23.0609 62.2207 22.8442 62.1865 22.6032C62.1518 22.3621 62.2034 22.098 62.3411 21.8109C62.5206 21.4369 62.7868 21.187 63.1404 21.0616C63.4941 20.9361 63.906 20.9614 64.3761 21.1378L64.5418 20.7917C64.6294 20.6091 64.7418 20.5502 64.8795 20.6158C65.0191 20.6822 65.0462 20.805 64.9608 20.9831H64.96ZM63.471 23.0237L64.07 21.7737C63.8607 21.7409 63.6834 21.7444 63.5381 21.7847C63.3928 21.8251 63.2768 21.9354 63.1902 22.1162C63.1036 22.297 63.0933 22.441 63.1471 22.5748C63.2009 22.7086 63.3088 22.8584 63.4706 23.0237H63.471ZM63.4221 24.1909L62.737 25.6204C62.9783 25.682 63.1906 25.6749 63.3742 25.5996C63.5577 25.5243 63.6918 25.3984 63.7763 25.222C63.8669 25.0328 63.8789 24.8587 63.8118 24.6996C63.7447 24.5405 63.615 24.3712 63.4226 24.1913L63.4221 24.1909Z"
        fill="#F0C06E"
      />
      <path
        d="M52.7755 24.5251C53.811 24.5251 54.6505 23.6879 54.6505 22.6551C54.6505 21.6224 53.811 20.7852 52.7755 20.7852C51.7399 20.7852 50.9004 21.6224 50.9004 22.6551C50.9004 23.6879 51.7399 24.5251 52.7755 24.5251Z"
        fill="#F8D987"
      />
      <path
        d="M66.1544 37.6484C67.3831 37.6484 68.3792 36.655 68.3792 35.4297C68.3792 34.2043 67.3831 33.2109 66.1544 33.2109C64.9257 33.2109 63.9297 34.2043 63.9297 35.4297C63.9297 36.655 64.9257 37.6484 66.1544 37.6484Z"
        fill="#F8D987"
      />
      <path
        d="M29.533 33.1312C31.6416 33.1312 33.3511 31.4264 33.3511 29.3234C33.3511 27.2204 31.6416 25.5156 29.533 25.5156C27.4243 25.5156 25.7148 27.2204 25.7148 29.3234C25.7148 31.4264 27.4243 33.1312 29.533 33.1312Z"
        fill="#F8D987"
      />
      <path
        d="M23.6514 32.3758C23.1739 31.4621 22.9043 30.4225 22.9043 29.3205C22.9043 28.1165 23.2262 26.9878 23.7889 26.0156"
        stroke="#1A1A1A"
        strokeWidth="1.80438"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.2823 18.8711L32.8867 23.793L42.2987 32.1531L46.6943 27.2312L37.2823 18.8711Z"
        fill="#D2EBE6"
      />
      <path
        d="M40.9005 26.4975C41.7061 25.5955 41.8616 24.4222 41.2477 23.8769C40.6338 23.3316 39.4831 23.6208 38.6774 24.5229C37.8718 25.425 37.7164 26.5983 38.3303 27.1436C38.9442 27.6888 40.0949 27.3996 40.9005 26.4975Z"
        fill="#B0D1C6"
      />
      <path d="M33.5137 23.7572L34.5623 24.6887L34.4472 22.707L33.5137 23.7572Z" fill="#B0D1C6" />
      <path d="M37.3173 19.4961L38.3659 20.4275L36.3789 20.5423L37.3173 19.4961Z" fill="#B0D1C6" />
      <path d="M42.2615 31.5306L41.2129 30.5991L43.1999 30.4844L42.2615 31.5306Z" fill="#B0D1C6" />
      <path d="M46.0657 27.2674L45.0176 26.3359L45.1322 28.3176L46.0657 27.2674Z" fill="#B0D1C6" />
      <path
        d="M37.5402 24.1629C37.899 24.1629 38.1898 23.8728 38.1898 23.515C38.1898 23.1572 37.899 22.8672 37.5402 22.8672C37.1815 22.8672 36.8906 23.1572 36.8906 23.515C36.8906 23.8728 37.1815 24.1629 37.5402 24.1629Z"
        fill="#B0D1C6"
      />
      <path
        d="M42.0363 28.159C42.3951 28.159 42.6859 27.8689 42.6859 27.5111C42.6859 27.1533 42.3951 26.8633 42.0363 26.8633C41.6776 26.8633 41.3867 27.1533 41.3867 27.5111C41.3867 27.8689 41.6776 28.159 42.0363 28.159Z"
        fill="#B0D1C6"
      />
      <path
        d="M31.8125 32.375L38.1904 41.8867"
        stroke="#1A1A1A"
        strokeWidth="1.80438"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.4648 17.2461L50.4927 41.886"
        stroke="#1A1A1A"
        strokeWidth="1.80438"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M60.6291 29.9766L56.1445 41.8869"
        stroke="#1A1A1A"
        strokeWidth="1.80438"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.5341 24.0547L48.0879 27.1729"
        stroke="#1A1A1A"
        strokeWidth="1.80438"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.416 29.7812L49.3294 34.7682"
        stroke="#1A1A1A"
        strokeWidth="1.80438"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M64.0694 36.3906L57.7422 37.6487"
        stroke="#1A1A1A"
        strokeWidth="1.80438"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PlantIcon;
